import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Tooltip } from '@mantine/core';
import { IconDatabaseImport } from '@tabler/icons-react';

import { InstPage, Platform, TgPage } from '../../../../types';
import { ImportPageModal } from '../ImportPageModal';

type ImportButtonProps = {
  platform: Platform;
  page: TgPage | InstPage;
};

export const ImportButton = ({ platform, page }: ImportButtonProps) => {
  return (
    <Tooltip label="Import Page History">
      <ActionIcon
        onClick={() => NiceModal.show(ImportPageModal, { pageId: page._id, platform })}
        radius="md"
        color={page.config.isImporting ? 'teal' : undefined}
      >
        <IconDatabaseImport />
      </ActionIcon>
    </Tooltip>
  );
};
